import React from 'react';
import { ShieldCheck, RefreshCw, Columns3 } from 'lucide-react';

const reasons = [
  {
    icon: ShieldCheck,
    title: 'Independent Recommendations',
    description: "We don't accept paid placements. Every recommendation is based on real testing and user feedback.",
  },
  {
    icon: RefreshCw,
    title: 'Updated Weekly',
    description: 'New models, pricing changes, and feature updates are reflected within days — not months.',
  },
  {
    icon: Columns3,
    title: 'Side-by-Side Comparisons',
    description: 'Compare up to 5 tools at once on features, pricing, and ratings. No other directory offers this.',
  },
];

export const WhyVergo: React.FC = () => {
  return (
    <section className="py-20 px-4 border-t border-border">
      <div className="container mx-auto max-w-5xl">
        <h2 className="text-3xl font-bold text-center mb-4">Why Vergo?</h2>
        <p className="text-center text-muted-foreground mb-12 max-w-xl mx-auto">
          What makes us different from every other AI directory.
        </p>
        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((r, i) => (
            <div key={i} className="space-y-3">
              <r.icon className="w-6 h-6 text-foreground" />
              <h3 className="text-lg font-semibold">{r.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{r.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
